/*
 * Handles current location clicks for the right-rail search experience.
 * Delegates the redirect behavior to the local currentLocationHandler.
 */

import redirectToCurrentLocation from './currentLocationHandler';

/**
 * trackSelection: dispatches a custom event to indicate that the user has selected
 * the current location option.
 * This is used for tracking purposes in the application.
 */
function trackSelection() {
  document.body.dispatchEvent(
    new CustomEvent('right_rail_search_selected', {
      detail: {
        selectedValue: null,
      },
    })
  );
}

/**
 * getCurrentLocation: Handles click events on elements with the data-current-location attribute.
 * If the clicked element is within a current location search container, it triggers a redirect to the
 * current location search page.
 * @param {Event} event - The click event object.
 * @returns {null} - Returns null if the clicked element is not within a current location search container.
 */
const getCurrentLocation = (event) => {
    if (event?.target?.closest('[data-current-location]')) {
        trackSelection();
        return redirectToCurrentLocation();
    }

    return null;
}

// Event delegation for current location searches. Right now only typeahead has the option to search by
// current location but we are ready in case they ask for it in another place like a search pill or similar.
  document.body.addEventListener('click', getCurrentLocation);
